module.exports = __webpack_public_path__ + "static/img/aqzs31.b9b3fb6b.jpg";